import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal, setLeaseTerms, setIsRentCalculated } from 'bundles/apex/deals/form/store/deal/actions';

import DealField from 'bundles/apex/deals/form/fields/field';
import LeaseTerms from 'bundles/apex/deals/lease_terms';

import './styles.scss';

export function DealLeaseTerms({
  changeDeal,
  deal,
  features,
  transactionSideOptions,
  setIsRentCalculated,
  setLeaseTerms,
}) {
  return (
    <LeaseTerms
      changeDeal={changeDeal}
      deal={deal}
      enableOperatingExpenses={features.operatingExpenses}
      transactionSideOptions={transactionSideOptions}
      onChange={setLeaseTerms}
      onIsRentCalculatedChange={setIsRentCalculated}
    />
  );
}

DealLeaseTerms.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.shape({
    leaseRateUnits: PropTypes.string,
    spaceSizeUnits: PropTypes.number,
  }).isRequired,
  features: PropTypes.shape({
    operatingExpenses: PropTypes.bool,
  }).isRequired,
  setIsRentCalculated: PropTypes.func.isRequired,
  setLeaseTerms: PropTypes.func.isRequired,
  show: PropTypes.bool,
  transactionSideOptions: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  features: state.features,
  transactionSideOptions: state.options.transactionSide,
});

const mapDispatchToProps = {
  changeDeal,
  setIsRentCalculated,
  setLeaseTerms,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealField(DealLeaseTerms, 'leaseStructure'));
